import { submitAccountRequest, SubmitReuqestAccountFormApiParameter, TempReturn } from "@cogentCustomBlueprint/Services/RequestAccountService";
import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

export interface RequestAccountParameter {
    companyName: string;
    companyStreetAddress: string;
    contactName: string;
    city: string;
    state: string;
    zipCode: string;
    phoneNumber: string;
    phoneNumberExt?: string;
    emailAddress: string;
    positionTitle: string;
    typeOfBusiness: string;
    message?: string;
    // onSuccess?: () => void;
    // onError?: (error: string) => void;
}
// type HandlerType = ApiHandlerDiscreteParameter<RequestAccountParameter, SubmitReuqestAccountFormApiParameter>;

type HandlerType = ApiHandler<
    RequestAccountParameter & HasOnSuccess & HasOnError<string>,
    SubmitReuqestAccountFormApiParameter
>;


// type HandlerType = ApiHandler<
//     RequestAccountParameter & HasOnSuccess & HasOnError<string>,
//     TempReturn
// >;


export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestAccountApi: HandlerType = async props => {
    props.apiResult = await submitAccountRequest(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.('error');
    }
};


export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [
    PopulateApiParameter,
    RequestAccountApi,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
];

const requestAccount = createHandlerChainRunner(chain, "RequestAccount");
export default requestAccount;
